import snakeCase from "lodash/snakeCase";
import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import NonVisualizerSubPart from "../subparts/nonVisualizerSubPart";

const alreadyExistingGroups = ["Edge Profile", "Faucet", "Sink"];

export default class Other extends Part {
  static id = 'Other';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Other';
    this.categoryEnabled = false;
  }

  load(dbFeature) {
    // console.log("load other", dbFeature.groupName);
    if (alreadyExistingGroups.includes(dbFeature.groupName)) { // they should be loaded in their groups!
      return false
    }
    const partId = snakeCase(dbFeature.groupName);
    let relatedItem = this.relatedItems.find(relatedItem => relatedItem.partId === partId);
    if (!relatedItem) {
      relatedItem = new NonVisualizerSubPart(true, partId, dbFeature.groupName);
      this.relatedItems.push(relatedItem);
    }
    relatedItem.getParent = () => this;
    relatedItem.load(dbFeature);
    return true
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
